// AGC: FarmProHub Main App Component
// AGC: Uses MainMenu as the main application shell

import React from 'react'
import { MainMenu } from './components/MainMenu'

const App: React.FC = () => {
  return <MainMenu />
}

export default App
